import { Typography } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import clsx from "clsx";
import { ReactNode } from "react";
import { COLORS } from "../muiTheme";

const useStyles = makeStyles()((theme) => ({
  container: {
    marginBottom: theme.spacing(10),
    width: "100%",
  },
  linearGradient: {
    background: `linear-gradient(to left, ${COLORS.blue}, ${COLORS.green});`,
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozBackgroundClip: "text",
    MozTextFillColor: "transparent",
  },
  subtitle: {
    marginTop: theme.spacing(2),
  },
}));

export default function HeaderText({
  children,
  white,
  small,
  subtitle,
}: {
  children: ReactNode;
  white?: boolean;
  small?: boolean;
  subtitle?: ReactNode;
}) {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <Typography
        variant={small ? "h2" : "h1"}
        component="h1"
        className={clsx({ [classes.linearGradient]: !white })}
      >
        {children}
      </Typography>
      {subtitle ? (
        <Typography component="div" className={classes.subtitle}>
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
}
